<template>
  <v-app>
    <router-view></router-view>
    <s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  components: {
  },

  data: () => ({
    //
  }),
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.$store.dispatch('setResponsive', false)
      } else {
        this.$store.dispatch('setResponsive', true)
      }
    }
  }
}
</script>
